// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_style_switch__2Ebva","selected":"switch_style_selected__2vCuP","unselected":"switch_style_unselected__3YusZ"};